import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PhotosPage from './PhotosPage';
import { User, UserService } from '../user';
import RemoteDataContent from '../common/ui-component/layouts/RemoteDataContent';
import { LOGIN_ROUTE } from '../Router';
import PhotoService from './PhotoService';
import { RemoteFile } from '../files';
import { isNotAsked, isSuccess } from '../utils/remote-data';

const UnauthenticatedPhotosPageProvider = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [decodeUserInfo, rDecodedUserInfo] = UserService.useGetDecodedUserInfo();
  const [getPhotos, rPhotos] = PhotoService.useGetPhotos();

  useEffect(() => {
    const hash = searchParams.get('h') || undefined;
    decodeUserInfo(hash);
  }, [decodeUserInfo, searchParams]);

  useEffect(() => {
    if (isSuccess(rDecodedUserInfo) && rDecodedUserInfo.value && isNotAsked(rPhotos)) {
      getPhotos(rDecodedUserInfo.value.id);
    }
  }, [getPhotos, rDecodedUserInfo, rPhotos]);

  return (
    <RemoteDataContent value={rDecodedUserInfo}>
      <RemoteDataContent.Success>
        {(user: User) => {
          return (
            <RemoteDataContent value={rPhotos}>
              <RemoteDataContent.Success>
                {(photos: RemoteFile[]) => {
                  return <PhotosPage user={user} existingPhotos={photos} refetchPhotos={getPhotos} />;
                }}
              </RemoteDataContent.Success>
            </RemoteDataContent>
          );
        }}
      </RemoteDataContent.Success>
      <RemoteDataContent.Failure>
        {() => {
          window.location.href = LOGIN_ROUTE;
          return (
            <div className="tw-flex tw-w-full tw-justify-center">
              <span>{t('redirect')}</span>
            </div>
          );
        }}
      </RemoteDataContent.Failure>
    </RemoteDataContent>
  );
};

export default UnauthenticatedPhotosPageProvider;
